export default __webpack_public_path__ + "static/media/Boots of the Masquer of the Sands.1bf3fd93.jpg";